import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from "@angular/router";
import { AlertsService } from "../alerts.service";
import { isPermission, Permission } from "./permissions";
import { UserService } from "./user.service";

export const permissionDataKey = "permission";
export const multiplePermissionDataKey = "somePermissions";

export const HasPermissionGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
): Promise<true | UrlTree> => {
  const router = inject(Router);
  const alerts = inject(AlertsService);
  const user = inject(UserService);

  const singlePermission: unknown = route.data[permissionDataKey];
  const somePermissions: unknown = route.data[multiplePermissionDataKey];

  const permissions = isPermissionsArray(somePermissions)
    ? somePermissions
    : [];
  if (isPermission(singlePermission)) {
    permissions.push(singlePermission);
  }

  if (permissions.length === 0) {
    throw new Error("Missing or invalid permission configuration for route.");
  }

  await user.isLoaded;

  for (const permission of permissions) {
    if (user.permissions.has(permission)) {
      return true;
    }
  }

  alerts.warn({
    title: "Access Denied",
    message: "You do not have permission to view that page.",
  });
  return router.parseUrl("/");
};

function isPermissionsArray(value: unknown): value is Permission[] {
  return Array.isArray(value) && value.every(isPermission);
}
